// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-form {
  width: 80%;
  margin: 25px auto;
  margin-bottom: 100px;
}
.card-form .form-title {
  margin: 30px 0 15px 0;
  color: #104a64;
}
.card-form .title-icon {
  margin-right: 15px;
  font-size: 1.6rem;
}
.card-form .form-add-consultant {
  width: 70%;
  margin: 50px auto 20px auto;
}
.card-form .bloc-inputs {
  margin: 25px auto;
}
.card-form .divider {
  height: 1px;
  border-top: 1px solid rgba(0, 0, 0, 0.12);
}
@media screen and (max-width: 960px) {
  .card-form .bloc-inputs > * {
    width: 100% !important;
  }
}

.etape-color {
  width: 7px;
  height: 7px;
  border-radius: 50%;
}

select {
  /* Reset Select */
  appearance: none;
  outline: 0;
  border: 0;
  box-shadow: none;
  /* Personalize */
  flex: 1;
  padding: 0 1em;
  background-color: var(--darkgray);
  background-image: none;
  cursor: pointer;
}

/* Remove IE arrow */
select::-ms-expand {
  display: none;
}

/* Custom Select wrapper */
.custom-select {
  position: relative;
  display: flex;
  height: 3em;
  border-radius: 0.25em;
  overflow: hidden;
  border: 2px solid #104a64;
  border-radius: 22px;
}

/* Arrow */
/* Transition */
.custom-select:hover::after {
  color: #f39c12;
}

/* TODO(mdc-migration): The following rule targets internal classes of select that may no longer apply for the MDC version. */
::ng-deep.mat-mdc-select-arrow {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/app/+home/+seller-consultants/seller-add-consultant/seller-add-consultant.component.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAEA;EACI,UAAA;EACA,iBAAA;EACA,oBAAA;AADJ;AAGI;EACI,qBAAA;EACA,cCPQ;ADMhB;AAII;EACI,kBAAA;EACA,iBAAA;AAFR;AAKI;EACI,UAAA;EACA,2BAAA;AAHR;AAMI;EACI,iBAAA;AAJR;AAOI;EACI,WAAA;EACA,yCAAA;AALR;AAOI;EACK;IACG,sBAAA;EALV;AACF;;AASA;EACI,UAAA;EACA,WAAA;EACA,kBAAA;AANJ;;AASA;EACI,iBAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,OAAA;EACA,cAAA;EAEA,iCAAA;EACA,sBAAA;EACA,eAAA;AAPJ;;AASE,oBAAA;AACA;EACE,aAAA;AANJ;;AAQE,0BAAA;AACA;EACE,kBAAA;EACA,aAAA;EAEA,WAAA;EACA,qBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;AANJ;;AAQE,UAAA;AAWA,eAAA;AACA;EACE,cAAA;AAfJ;;AAiBE,6HAAA;AACA;EACE,aAAA;AAdJ","sourcesContent":["@import \"/src/styles/variables\";\r\n\r\n.card-form {\r\n    width: 80%;\r\n    margin: 25px auto;\r\n    margin-bottom: 100px;\r\n\r\n    .form-title {\r\n        margin: 30px 0 15px 0;\r\n        color: $primary-color;\r\n    }\r\n\r\n    .title-icon {\r\n        margin-right: 15px;\r\n        font-size: 1.6rem;\r\n    }\r\n\r\n    .form-add-consultant {\r\n        width: 70%;\r\n        margin: 50px auto 20px auto;\r\n    }\r\n\r\n    .bloc-inputs {\r\n        margin: 25px auto;\r\n    }\r\n\r\n    .divider {\r\n        height: 1px;\r\n        border-top: 1px solid rgba(0, 0, 0, 0.12);\r\n    }\r\n    @media screen and (max-width: 960px) {\r\n         .bloc-inputs > * {\r\n            width: 100%!important;\r\n        }\r\n    }\r\n}\r\n\r\n.etape-color {\r\n    width: 7px;\r\n    height: 7px;\r\n    border-radius: 50%;\r\n}\r\n\r\nselect {\r\n    /* Reset Select */\r\n    appearance: none;\r\n    outline: 0;\r\n    border: 0;\r\n    box-shadow: none;\r\n    /* Personalize */\r\n    flex: 1;\r\n    padding: 0 1em;\r\n    //color: #fff;\r\n    background-color: var(--darkgray);\r\n    background-image: none;\r\n    cursor: pointer;\r\n  }\r\n  /* Remove IE arrow */\r\n  select::-ms-expand {\r\n    display: none;\r\n  }\r\n  /* Custom Select wrapper */\r\n  .custom-select {\r\n    position: relative;\r\n    display: flex;\r\n    //width: 20em;\r\n    height: 3em;\r\n    border-radius: .25em;\r\n    overflow: hidden;\r\n    border: 2px solid #104a64;\r\n    border-radius: 22px;\r\n  }\r\n  /* Arrow */\r\n//   .custom-select::after {\r\n//     content: '\\25BC';\r\n//     position: absolute;\r\n//     top: 0;\r\n//     right: 0;\r\n//     padding: 1em;\r\n//     background-color: #34495e;\r\n//     transition: .25s all ease;\r\n//     pointer-events: none;\r\n//   }\r\n  /* Transition */\r\n  .custom-select:hover::after {\r\n    color: #f39c12;\r\n  }\r\n  /* TODO(mdc-migration): The following rule targets internal classes of select that may no longer apply for the MDC version. */\r\n  ::ng-deep.mat-mdc-select-arrow {\r\n    display: none;\r\n  }","// Général\r\n$content-background-color: white;\r\n$primary-color: #104a64;\r\n$success-color: #badbcc;\r\n$success-text-color: #0f5132;\r\n$error-color: #f5c2c7;\r\n$error-text-color: #842029;\r\n$secondary-color: #e9af51;\r\n$secondary-color-light: #e9af51a1;\r\n$danger-color: rgb(255, 79, 79);\r\n$page-title-size: 2.3rem;\r\n$common-size: 1.05rem;\r\n$background-light: #104a64;\r\n\r\n// Header\r\n$width-logo: 145px;\r\n$filter-logo: brightness(0) invert(1);\r\n$header-height: 70px;\r\n$header-color-bottom-border: #cbd3db;\r\n\r\n// Left menu\r\n$left-menu-text-color: white;\r\n\r\n// GED\r\n$ged-background-hover-color: #e9af5128;\r\n$ged-folder-color: $primary-color;\r\n$ged-file-color: $primary-color;\r\n$ged-folder-color-hover: #0056b3;\r\n$ged-file-color-hover: #0056b3;\r\n\r\n// Data Tree\r\n$data-tree-left-menu-width: 300px;\r\n$data-tree-article-title-font-size: 2.8rem;\r\n$data-tree-highlight-color: $secondary-color;\r\n\r\n// See rooms\r\n$see-rooms-title-size: 1.7rem;\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
